import { Box, Input } from "@chakra-ui/react";

/**
 * Netlify Forms honeypot — must be in the POST body (empty) when the
 * static HTML stub declares netlify-honeypot="bot-field". Bots that fill
 * it are silently rejected; humans never see it.
 */
const NetlifyHoneypot = () => (
  <Box
    as="p"
    aria-hidden="true"
    position="absolute"
    left="-10000px"
    top="auto"
    w="1px"
    h="1px"
    overflow="hidden"
  >
    <label>
      Don’t fill this out if you’re human:
      <Input name="bot-field" type="text" tabIndex={-1} autoComplete="off" />
    </label>
  </Box>
);

export default NetlifyHoneypot;
